import ApiClient from './apiClient'
import {
  GetTeamListResponse,
  AddTeamRequest,
  UpdateTeamRequest,
  Team,
  TeamCondition,
} from '../types/team'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getReportTeam = async (params: TeamCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/team',
  (response: Team) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTeamList = async (): Promise<any> => ApiClient.get(
  '/api/setting/team',
  (teamList: GetTeamListResponse) => teamList,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTeam = async (params: AddTeamRequest): Promise<any> => ApiClient.post(
  '/api/setting/team',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTeam = async (teamId: number, params: UpdateTeamRequest): Promise<any> => ApiClient.patch(
  `/api/setting/team/${teamId}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTeam = async (teamId: number): Promise<any> => ApiClient.delete(
  `/api/setting/team/${teamId}`,
  () => {
    // do nothing
  },
)
